import { useState } from 'react';

import CustomModal from '@/components/CustomModal';
import { RadioButtonGroup } from '@/components/RadioButton';
import Select from '@/components/Select';
import { STATUS_OPTIONS } from '@/constants/constant';
import { ERoleAccess } from '@/enum';
import useAccess from '@/hooks/useAccess';
import { useFormatText } from '@/hooks/useFormatText';
import { ILessonFilterValues } from '@/types';

const LessonFilterModal = ({
  setIsOpen,
  onApply,
  initialValues,
  classOptions = [],
}: {
  setIsOpen: (open: boolean) => void;
  onApply: (filters: ILessonFilterValues) => void;
  initialValues?: Partial<ILessonFilterValues>;
  classOptions?: { value: string; label: string }[] | [];
}) => {
  const { hasAccess } = useAccess();

  const { formatText } = useFormatText();
  const [status, setStatus] = useState(initialValues?.status || '');
  const [classId, setClassId] = useState<string[]>(
    initialValues?.class_id || []
  );
  // const [levels, setLevels] = useState<string[]>(initialValues?.levels || []);

  const handleClear = () => {
    setStatus('');
    setClassId([]);
    // setLevels([]);
    onApply({
      status: '',
      class_id: [],
      // levels: [],
    });
    setIsOpen(false);
  };

  const handleApply = () => {
    onApply({
      status,
      class_id: classId,
      // levels,
    });
    setIsOpen(false);
  };

  if (!hasAccess(ERoleAccess.USER_MANAGEMENT)) return null;

  return (
    <CustomModal
      setIsOpen={setIsOpen}
      isHeader
      isFooter
      heading={formatText('common.actions.filter')}
      position="right"
      className="max-w-150"
      confirmButtonProps={{
        label: formatText('common.actions.show-results'),
        variant: 'primary',
        onClick: handleApply,
        disabled: !status && !classId.length,
      }}
      cancelButtonProps={{
        label: formatText('common.actions.clear-filters'),
        desructive: true,
        onClick: handleClear,
        className: 'text-sm underline px-0!',
      }}
    >
      <div className="flex flex-col gap-6 w-full">
        {/* Status */}
        <RadioButtonGroup
          name="status"
          label={formatText('user-management.filters.status')}
          options={STATUS_OPTIONS}
          value={status}
          onChange={setStatus}
          gap="gap-4"
          formatLabel={formatText}
        />
        {/* Classes */}
        <div>
          <Select
            name={formatText('user-management.filters.classes')}
            options={classOptions}
            selected={classId}
            onChange={(val) => setClassId(Array.isArray(val) ? val : [])}
            placeholder={formatText('user-management.filters.select-class')}
            className="w-full"
            dropdownClassName="w-full left-0"
            isMulti
            isClearable
          />
        </div>
        {/* Levels */}
        {/* <div>
          <Select
            name={formatText('user-management.filters.levels')}
            options={LESSON_STAGE_OPTIONS}
            selected={levels}
            onChange={(val) => setLevels(Array.isArray(val) ? val : [])}
            placeholder={formatText('user-management.filters.select-level')}
            className="w-full"
            dropdownClassName="w-full left-0"
            isMulti
            isClearable
            isTextFormat
          />
        </div> */}
      </div>
    </CustomModal>
  );
};

export default LessonFilterModal;
